/**
 * Determines if a string is
 * null, undefined, or only whitespace
 *
 * @param input string input
 */
export function isNullOrWhitespace(input: string) {
  if (input === null || input === undefined) {
    return true;
  }

  return input.toString().trim() === '';
}
